

import React, { memo } from 'react';

import _capitalize from 'lodash.capitalize';
import _get from 'lodash.get';

import { PageHeader, useWithResolvedBucketKeys, NUMERIC_MEDIA_SIZES } from '../../../ui-kit';

import { isAnonymousUser } from '../../../common/utils';
import Members from './Members';
import DISPLAYED_MEMBERS from '../constants/displayedMembers';




























const createPopupOption = (
action, label) => (
{ action, label });

function CollaborationPageHeader({
  containerSize,
  showCollaborationModal,
  showShareModal,
  resourceMembers = [],
  reviewMembers = [],
  isPrivate,
  isShared,
  resourceName = '',
  actionPopupOptions,
  secondaryContent,
  darkMode,
  loading,
  hideMembers,
  showPrivateSettingsModal,
  displayedMembersType = DISPLAYED_MEMBERS.RESOURCE,
  apiClient,
  organisationId,
  hideActionPopup = false,
  secondaryRightAddons,
  ...otherProps
}) {
  const { data: resolvedReviewMembers } = useWithResolvedBucketKeys({
    apiClient,
    data: reviewMembers,
    organisationId,
    substitutedKeys: ['imageUrl']
  }, []);

  const isSmall = containerSize.width && containerSize.width <= NUMERIC_MEDIA_SIZES.small;

  const isAnonymous = isAnonymousUser();

  const getDefaultPopupOptions = () => {
    const setAccessOption = createPopupOption(showPrivateSettingsModal, `Set As ${isPrivate ? 'Public' : 'Private'}`);

    const collaboratorsOption = _get(resourceMembers, 'length') ?
    createPopupOption(showCollaborationModal, 'Edit Collaborators') : null;

    const shareOption = isPrivate || isShared ?
    null : createPopupOption(showShareModal, `Share ${_capitalize(resourceName.toLowerCase())}`);

    return [collaboratorsOption, shareOption, setAccessOption];
  };

  const getPopupOptions = () => {
    const defaultOptions = getDefaultPopupOptions();
    // this happens because the order of the options is important
    return [
    ...[actionPopupOptions[0], ...defaultOptions, actionPopupOptions[1]],
    ...(actionPopupOptions.length > 2 ? actionPopupOptions.slice(2) : [])];

  };

  const getFilteredPopupOptions = () => getPopupOptions().filter(Boolean);

  const mergedActionPopupOptions = isAnonymous || hideActionPopup ?
  null : getFilteredPopupOptions();

  const showMembers = !hideMembers && !isAnonymous && !isSmall;

  return (
    <PageHeader
      actionPopupOptions={mergedActionPopupOptions}
      darkMode={darkMode}
      isAnonymous={isAnonymous}
      loading={loading}
      {...otherProps}
      secondaryContent={!loading &&
      <>
          {secondaryContent}
          {showMembers &&
        <Members
          displayedMembersType={displayedMembersType}
          resourceMembers={resourceMembers}
          reviewMembers={resolvedReviewMembers}
          darkMode={darkMode}
          showCollaborationModal={showCollaborationModal} />}


          {secondaryRightAddons}
        </>} />);



}

CollaborationPageHeader.defaultProps = {
  actionPopupOptions: []
};

export default memo(CollaborationPageHeader);